import Vue from 'vue'
import Component from 'vue-class-component'

import { sharedInstance as authService } from '@/services/AuthService'

import store from '@/store'

@Component
export default class AuthMixin extends Vue
{
	get isSignedIn() {
		return store.getters['auth/signedIn']
	}

	get signedInUser() {
		if (!this.isSignedIn)
		{
			return {}
		}
		return store.getters['auth/user']
	}

	get photoURL()
	{
		if (!this.isSignedIn)
		{
			return null
		}

		return this.signedInUser.photoURL
	}

	mounted()
	{
		if (authService.isSignedIn)
		{
			this._onUserAuthed(authService.user)
			return
		}

		authService.onSignedInAsObservable().subscribe(user => {
			this._onUserAuthed(user)
		})
	}

	private _onUserAuthed(user: firebase.User | UserData | null)
	{
		if (!user)
		{
			return
		}

		// fullstory identity
		// @ts-ignore
		const fullStory = window.FS
		if (fullStory)
		{
			fullStory.identify(user.uid, {
				displayName: user.displayName,
				email: user.email
				// TODO: Add your own custom user variables here, details at
				// http://help.fullstory.com/develop-js/setuservars
			})
		}

		this.onUserAuthed(user)
	}

	protected onUserAuthed (user: firebase.User | UserData | null)
	{
	}
}
